import { render } from "./QuesHint.vue?vue&type=template&id=17d0e4ec&scoped=true&ts=true"
import script from "./QuesHint.vue?vue&type=script&lang=ts"
export * from "./QuesHint.vue?vue&type=script&lang=ts"

import "./QuesHint.vue?vue&type=style&index=0&id=17d0e4ec&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d0e4ec"]])

export default __exports__